
<div class="container">
  <div class="table-card">
    <div class="row">
      <div class="col">
        <p class="text-center">User &amp; Project Statistics</p>
      </div>
    </div>
    <div class="row">
      <div class="col"> </div>
      <div class="col"><a class="btn btn-primary btn-block" id="exportStatistics" [downloadFile]="'/api/users/export-user-stats-report'"><span class="oi oi-cloud-download"></span> Export Statistics Report</a></div>
      <div class="col"> </div>
    </div>
  </div>
</div>